import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/collections/license.collectionOwner.set.mutation.gql"
import type {
  SetCollectionOwnerMutation,
  SetCollectionOwnerMutationVariables,
} from "@/v2-backoffice-client/license/collections/__types__/license.collectionOwner.set.mutation"

type Options = MutationHookOptions<
  SetCollectionOwnerMutation,
  SetCollectionOwnerMutationVariables
>

export function useSetCollectionOwnerMutation(options?: Options) {
  return useMutation<
    SetCollectionOwnerMutation,
    SetCollectionOwnerMutationVariables
  >(mutation, options)
}
